import { createFileRoute } from "@tanstack/react-router";
import { Mlp20CampaignV2Page } from "@/components/campaign/Mlp20CampaignV2Page";

const TITLE = "Запознайте се с MLP 2.0 | Демо от Perceptica";
const DESCRIPTION = "Вижте как Perceptica MLP 2.0 свързва промените в медийното отразяване с публикации, теми, репорти и експертен анализ.";

export const Route = createFileRoute("/bg/mlp-2-0")({
  head: () => ({
    meta: [
      { title: TITLE }, { name: "description", content: DESCRIPTION }, { name: "robots", content: "noindex, follow" },
      { property: "og:title", content: TITLE }, { property: "og:description", content: DESCRIPTION }, { property: "og:type", content: "website" },
      { property: "og:url", content: "https://perceptica.com/bg/mlp-2-0" }, { property: "og:image", content: "https://perceptica.com/og/bg-mlp-2-0.jpg" },
      { property: "og:image:width", content: "1200" }, { property: "og:image:height", content: "630" }, { property: "og:image:alt", content: "Платформа за медиен мониторинг Perceptica MLP 2.0" },
      { name: "twitter:card", content: "summary_large_image" }, { name: "twitter:title", content: TITLE }, { name: "twitter:description", content: DESCRIPTION }, { name: "twitter:image", content: "https://perceptica.com/og/bg-mlp-2-0.jpg" },
    ],
  }),
  component: () => <Mlp20CampaignV2Page locale="bg" />,
});
